<template>
  <div>
    <v-header></v-header>

    <div   class="container" style="padding-top: 60px;">
      <div   class="banner">
        <img   src="../../static/img/banner-6.png" alt="" />
        <div   class="box">
          <span   style="font-size: 28px;">新高考排选课</span>
          <span   style="margin-top: 10px;">因材施教，实现资源优化组合，为学校减负增效</span>
          <router-link to="/applyfortrial"><input   type="button" value="申请试用" /></router-link>
        </div>
      </div>
      <div   class="introduction">
        <h2   class="item-title"><span   class="eg">PRODUCT INTRODUCTION</span> <span   class="ch">产品简介</span></h2>
        <p   class="product-introduction">为新高考课改定制的排课算法，针对 “7 选 3”或“6 选 3”带来的选课、分班、排课、成绩分析等问题，通过智能算法，为老师、学生、学校提供个性化、专业走班排课解决方案，便捷的调课代课操作，课表统一管理。</p>
      </div>
      <div   class="features">
        <h2   class="item-title"><span   class="eg">FEATURES</span> <span   class="ch">功能特色</span></h2>
        <div   class="item-pro">
          <dl  >
            <dt  >
              <input   type="button" value="多种模式选课" class="title" />
            </dt>
            <dd  >
              支持多种走班选择模式，支持7选3、6选3、M选N支持自由选模式，固二选一等多种套餐制
            </dd>
          </dl>
          <dl  >
            <dt  >
              <input   type="button" value="多种分层教学" class="title" />
            </dt>
            <dd  >
              支持走班行政班的多条件和规则下的分层教学
            </dd>
          </dl>
          <dl  >
            <dt  >
              <input   type="button" value="混合排课" class="title" />
            </dt>
            <dd  >
              支持走班排课的同时支持传统排课，并且能够统一的在云端完成排课
            </dd>
          </dl>
          <dl  >
            <dt  >
              <input   type="button" value="高可用安全保障" class="title" />
            </dt>
            <dd  >
              云端存储，数据安全可靠，并行计算瞬时响应
            </dd>
          </dl>
          <dl  >
            <dt  >
              <input   type="button" value="多规则条件设置" class="title" />
            </dt>
            <dd  >
              支持单双周、早中晚自习、连堂等多条件规则灵活设置
            </dd>
          </dl>
          <dl  >
            <dt  >
              <input   type="button" value="灵活调课" class="title" />
            </dt>
            <dd  >
              支持灵活调课，代课，即时发布课表多终端实时同步
            </dd>
          </dl>
        </div>
      </div>
      <div   class="process">
        <h2   class="item-title"><span   class="eg">“ONE PERSON，ONE LESSON” USE PROCESS</span> <span   class="ch">“一人一课表” 使用流程</span></h2>
        <div   class="process-line" style="margin-top: 50px;">
          <div  >
            <div   class="point pointRight">
              <span   class="round">01</span>
              <span  >在线选课</span>
            </div>
            <div  >
              <span   class="round">02</span>
              <span  >智能选课</span>
            </div>
          </div>
          <div   style="margin: 10px 0px;">
            <div  ></div>
            <div  >
              <img src="../../static/img/process-2.png" style="width: 8px;
    height: 24px;">
            </div>
          </div>
          <div  >
            <div   class="point pointLeft">
              <span   class="round">04</span>
              <span  >灵活调课</span>
            </div>
            <div  >
              <span   class="round">03</span>
              <span  >课表分析</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-footer></v-footer>
  </div>
</template>

<script>
  import Vue from 'vue'
  import header from './header.vue'
  import footer from './footer.vue'
  export default {
    name: 'HelloWorld',
    data () {
      return {

      }
    },
    components :{
      'v-header':header,
      'v-footer':footer,
    },
    methods: {

    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .introduction {
    padding: 50px 0;
  }
  .item-title {
    text-align: center;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-direction: column;
    flex-direction: column;
  }
  .product-introduction{
    margin-top: 40px;
    padding: 0 5%;
    letter-spacing: 1px;
    line-height: 24px;
  }
  .banner {
    width: 100%;
    color: #fff;
    position: relative
  }

  .banner img {
    width: 100%
  }

  .banner input[type=button] {
    width: 100px;
    height: 40px;
    background: #ff9a00;
    color: #fff;
    border-radius: 20px;
    font-size: 14px;
    margin-top: 20px
  }

  .banner .box {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    margin-left: 43px;
    -ms-flex-direction: column;
    flex-direction: column
  }

  .introduction {
    padding: 50px 0
  }

  .features {
    background: #f9f9f9;
    padding: 50px 0
  }

  .features .item-pro {
    padding: 0;
    width: 100%;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    box-sizing: border-box
  }

  .features .item-pro dl {
    width: 50%;
    margin: 40px 0 0
  }

  .features .item-pro dt {
    width: 100%;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center
  }

  .features .item-pro dt img {
    width: 0;
    height: 0
  }

  .features .item-pro dd {
    width: 100%;
    text-align: center;
    margin: 15px 0 0
  }

  .features .item-pro dd .title {
    font-size: 16px
  }

  .features .item-pro dd .note {
    margin: 0;
    font-size: 12px;
    line-height: 18px;
    text-align: center
  }

  .features .item-pro .title {
    height: 40px;
    width: 130px;
    border-radius: 5px
  }

  .features .item-pro dd {
    padding: 0 10px;
    box-sizing: border-box;
    text-align: left;
    line-height: 24px
  }

  .process {
    padding: 50px 0
  }

  .process-line .round {
    height: 25px;
    width: 25px;
    border-radius: 50%;
    text-align: center;
    line-height: 26px;
    color: #fa992d;
    background: #fff;
    margin: 0 15px
  }

  .process-line>div {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: distribute;
    justify-content: space-around;
    -ms-flex-align: center;
    align-items: center;
    position: relative
  }

  .process-line>div:not(:nth-child(2))>div {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: start;
    justify-content: flex-start;
    -ms-flex-align: center;
    align-items: center;
    width: 40%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    background: #fa992d;
    border-radius: 5px
  }

  .process-line .point :after {
    content: "";
    height: 8px;
    width: 24px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -12px;
    margin-top: -4px
  }
  .process-line .pointRight :after {
    background: url("~@/../static/img/process-1.png") no-repeat;
    background-size: 100% 100%;
  }
  .process-line .pointLeft :after {
    background: url("~@/../static/img/process-3.png") no-repeat;
    background-size: 100% 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/campuspayment.vue